import Datetime from "./Datetime.vue";
import Duration from "./Duration.vue";
import Monetary from "./Monetary.vue";
import Numeric from "./Numeric.vue";
import Percentage from "./Percentage.vue";
import URL from "./URL.vue";
import Vanity from "./Vanity.vue";

export default {
  Datetime,
  Duration,
  Monetary,
  Numeric,
  Percentage,
  URL,
  Vanity,
};
